import { Model } from 'modules/core/lib/mobx-rest'

interface IEvent {
  [key: string]: any
}

class Event extends Model<IEvent> {
  static urlRoot() {
    return '/posts/events'
  }
}

export default Event
